import React from 'react'
import { Link } from 'react-router-dom'
import CardUI from '../../../widgets/layout/CardUI'
import './EMITrackerSummary.css'

const DuesSummaryV1Card = ({ totals, onDsraIntClick, onDefaultIntClick, onClearFilter, onShortfallClick }) => {
  return (
    <CardUI title='Dues Summary (V1)'>
      <table className='table_emi'>
        <tbody>
          <tr>
            <th /><th />
            <th className='g_p_left_100'><Link onClick={onClearFilter} to='#'>Due Amounts</Link></th>
            <th className='g_p_left_100'>Paid Amounts</th>
            <th className='g_p_left_100'>
              <Link onClick={onShortfallClick} to='#'>Shortfall</Link>
            </th>
          </tr>
          <tr>
            <td>A</td>
            <td>EMI</td>
            <td className='g_text_right g_p_left_100'>{totals.totalEMIF5}</td>
            <td className='g_text_right g_p_left_100'>{totals.totalEMIPaidF5}</td>
            <td className='g_text_right g_p_left_100'>{totals.totalEMIShortfallF5}</td>
          </tr>
          <tr>
            <td>B</td>
            <td>GST</td>
            <td className='g_text_right'>{totals.totalGSTF5}</td>
            <td className='g_text_right'>{totals.totalGSTPaidF5}</td>
            <td className='g_text_right'>{totals.totalGSTShortFallF5}</td>
          </tr>
          <tr>
            <td>C</td>
            <td>TDS (Gensol)</td>
            <td className='g_text_right'>({totals.totalTDSF5})</td>
            <td className='g_text_right'>({totals.totalTDSPaidF5})</td>
            <td className='g_text_right'>({totals.totalTDSShortFallF5})</td>
          </tr>
          <tr>
            <td>D</td>
            <td><Link onClick={onDsraIntClick} to='#'>DSRA interest</Link></td>
            <td className='g_text_right'>{totals.totalDSRADipInterestF5}</td>
            <td className='g_text_right'>{totals.totalDSRADipInterestPaidF5}</td>
            <td className='g_text_right'>{totals.totalDSRAShortfallF5}</td>
          </tr>
          <tr>
            <td>E</td>
            <td><Link onClick={onDefaultIntClick} to='#'>Penal Charge</Link></td>
            <td className='g_text_right'>{totals.totalDefaultInterestF5}</td>
            <td className='g_text_right'>{totals.totalDefaultInterestPaidF5}</td>
            <td className='g_text_right' >{totals.totalDefaultShortfallF5}</td>
          </tr>
          {/*
          <tr>
            <td>F</td>
            <td>Prior due</td>
            <td className='g_text_right'>{totals.totalPriorDueF5}</td>
            <td className='g_text_right'>{totals.totalPriorPaidF5}</td>
            <td className='g_text_right'></td>
          </tr>
          */}
          <tr>
            <td></td>
            <td><b>Subtotal</b></td>
            <td className='g_text_right'><b>{totals.totalPayableF5}</b></td>
            <td className='g_text_right'><b>{totals.totalPaidMonthF5}</b></td>
            <td className='g_text_right'><b>{totals.totalShortfallF5}</b></td>
          </tr>
          <tr>
            <td />
            <td><b><a href='#prepayment'>Prepayments</a></b></td>
            <td />
            <td className='g_text_right'><b>{totals.totalPrePaidAmountF5}</b></td>
            <td />
          </tr>
          <tr>
            <td />
            <td><b>Overdues paid</b></td>
            <td />
            <td className='g_text_right'><b>{totals.totalPriorPaidF5}</b></td>
            <td />
          </tr>
          <tr>
            <td />
            <td><b>Total paid</b></td>
            <td />
            <td className='g_text_right'><b>{totals.grandTotalPaidF5}</b></td>
            <td />
          </tr>
        </tbody>
      </table>
    </CardUI>
  )
}

const OverduesV2SummaryCard = () => {
  return (
    <CardUI title='Overdues V2 Summary'>
      <table className='table_emi'>
        <tbody>
          <tr>
            <th /><th />
            <th className='g_p_left_100'>Due Amounts</th>
            <th className='g_p_left_100'>Paid Amounts</th>
            <th className='g_p_left_100'>Shortfall</th>
          </tr>
          <tr>
            <td>A</td>
            <td>EMI</td>
            <td className='g_text_right g_p_left_100'>{ }</td>
            <td className='g_text_right g_p_left_100'>{ }</td>
            <td className='g_text_right g_p_left_100'>{ }</td>
          </tr>
          <tr>
            <td>D</td>
            <td>DSRA interest</td>
            <td className='g_text_right'>{ }</td>
            <td className='g_text_right'>{ }</td>
            <td className='g_text_right'>{ }</td>
          </tr>
          <tr>
            <td>E</td>
            <td>Penal Charge</td>
            <td className='g_text_right'>{ }</td>
            <td className='g_text_right'>{ }</td>
            <td className='g_text_right' >{ }</td>
          </tr>
          <tr>
            <td></td>
            <td><b>Repayments</b></td>
            <td className='g_text_right'><b>{ }</b></td>
            <td className='g_text_right'><b>{ }</b></td>
            <td className='g_text_right'><b>{ }</b></td>
          </tr>
        </tbody>
      </table>
    </CardUI>
  )
}

const PaymentSummaryCard = ({ totals }) => {
  return (
    <CardUI className='g_m_top_100' title='Payment Summary'>
      <div className='g_flex_v'>
        <table>
          <tr>
            <th></th>
            <th className='g_text_right'>Txn count</th>
            <th className='g_text_right'>Total amount</th>
          </tr>
          <tr>
            <td>Auto payment initiated</td>
            <td className='g_text_right'>{totals.totalAutoPaymentInitiatedCount}</td>
            <td className='g_text_right'>{totals.totalAutoPaymentInitiatedF5}</td>
          </tr>
          <tr>
            <td>Auto payment paid</td>
            <td className='g_text_right'>{totals.totalAutoPaymentPaidCount}</td>
            <td className='g_text_right'>{totals.totalAutoPaymentPaidF5}</td>
          </tr>
          <tr>
            <td>Manual payment initiated</td>
            <td className='g_text_right'>{totals.totalManualPaymentInitiatedCount}</td>
            <td className='g_text_right'>{totals.totalManualPaymentInitiatedF5}</td>
          </tr>
          <tr>
            <td>Manual payment paid</td>
            <td className='g_text_right'>{totals.totalManualPaymentPaidCount}</td>
            <td className='g_text_right'>{totals.totalManualPaymentPaidF5}</td>
          </tr>
        </table>
        {/* <span>
          Total payment initiated:
          <span className='g_m_left_50'>{ }</span>
        </span>
        <span>
          Total payment not initiated:
          <span className='g_m_left_50'>{ }</span>
        </span> */}
      </div>
    </CardUI>
  )
}

const EMITrackerSummary2UI = ({ totals, onDsraIntClick, onDefaultIntClick, onClearFilter, onShortfallClick, onPrepaidClick }) =>
  <div className='g_flex_h g_flex_top'>
    <DuesSummaryV1Card 
      totals={totals}
      onDsraIntClick={onDsraIntClick}
      onDefaultIntClick={onDefaultIntClick}
      onClearFilter={onClearFilter}
      onShortfallClick={onShortfallClick}
    />
    <span>
      <div className='g_flex_v'>
        <span className='g_text_right g_flex_v'>
          <span>Auto-collections scheduled for <b>{new Date(totals.yearMonth.year, totals.yearMonth.month, 0).getDate()}-{totals.yearMonth.month > 9 ? totals.yearMonth.month : '0' + totals.yearMonth.month}-{totals.yearMonth.year} 10:00</b></span>
          {
            totals.yearMonth.current &&
            <span>Auto-collections completed on <b>{totals.autoCollectionCompletedDateTime}</b></span>
          }
        </span>
        <OverduesV2SummaryCard />
        <PaymentSummaryCard totals={totals} />
      </div>
    </span>
  </div>

const lastDayOfMonth = ({ yearMonth }) => {
  return;
}
export default EMITrackerSummary2UI
